import { Action } from '@ngrx/store'

export const UPDATE_FUZZY_SEARCH =  '[FILTER] Update Fuzzy Search Text';

export type Actions = UpdateFuzzySearch;

export class UpdateFuzzySearch implements Action {
  readonly type = UPDATE_FUZZY_SEARCH;

  constructor(public payload: string) {}
}
